/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import sadGuy from "assets/images/blank-lage.svg";
import starBgGradient from "assets/images/starBgGradient.svg";
import { Button } from "components/base/_common/index";
import styles from "./ErrorPage.module.scss";

export default class extends React.Component {
  render() {
    return (
      <div className={styles.errorPage} style={{ backgroundImage: `url(${starBgGradient})` }}>
        <div>
          <div className={styles.errorPageContent}>
            <div className={styles.errorPageText}>
              <div>
                <img src={sadGuy} alt="sad guy so mellow" />
              </div>

              <h3 className={styles.textSubHeading}>
                <Trans i18nKey="ErrorNetwork.heading">Network error</Trans>
              </h3>
              <div className={styles.textContent}>
                <Trans i18nKey="ErrorNetwork.textContent">
                  <p>You are having network issues.</p>
                  <p>Please check your internet connection.</p>
                </Trans>

                <div>
                  <Link to="/">
                    <Button>
                      <Trans i18nKey="ErrorNetwork.buttonAction">Back To Home</Trans>
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
